module.exports = __webpack_public_path__ + "images/patterns/light/DotsChecker.a70142c225011e8d6c67.svg";